/**
 * "Architecture overview" — Introduction section (ADR-0074).
 * Structure + `docs.*` keys only; prose lives in the per-locale catalogs.
 * A user-level overview (data residency, reliability, isolation) — not internal
 * implementation detail. Reconciled from `product/architecture/*` and the audits.
 */
import type { DocPageContent } from '../types';

export const ARCHITECTURE_PAGE: DocPageContent = {
  slug: 'architecture',
  titleKey: 'docs.architecture.title',
  descriptionKey: 'docs.architecture.description',
  blocks: [
    { kind: 'paragraph', textKey: 'docs.architecture.lead' },

    {
      kind: 'heading',
      level: 2,
      id: 'request-path',
      textKey: 'docs.architecture.requestPath.heading',
    },
    { kind: 'paragraph', textKey: 'docs.architecture.requestPath.body' },
    {
      kind: 'steps',
      steps: [
        {
          titleKey: 'docs.architecture.requestPath.step.ask.title',
          textKey: 'docs.architecture.requestPath.step.ask.text',
        },
        {
          titleKey: 'docs.architecture.requestPath.step.plan.title',
          textKey: 'docs.architecture.requestPath.step.plan.text',
        },
        {
          titleKey: 'docs.architecture.requestPath.step.act.title',
          textKey: 'docs.architecture.requestPath.step.act.text',
        },
      ],
    },

    {
      kind: 'heading',
      level: 2,
      id: 'browser-gate',
      textKey: 'docs.architecture.browserGate.heading',
    },
    { kind: 'paragraph', textKey: 'docs.architecture.browserGate.body' },

    {
      kind: 'heading',
      level: 2,
      id: 'reliability',
      textKey: 'docs.architecture.reliability.heading',
    },
    { kind: 'paragraph', textKey: 'docs.architecture.reliability.body' },

    { kind: 'heading', level: 2, id: 'residency', textKey: 'docs.architecture.residency.heading' },
    { kind: 'paragraph', textKey: 'docs.architecture.residency.body' },
    {
      kind: 'callout',
      tone: 'note',
      titleKey: 'docs.architecture.residency.note.title',
      textKey: 'docs.architecture.residency.note.body',
      links: { trust: { target: { path: '/trust' }, labelKey: 'docs.common.link.trust' } },
    },

    { kind: 'heading', level: 2, id: 'isolation', textKey: 'docs.architecture.isolation.heading' },
    { kind: 'paragraph', textKey: 'docs.architecture.isolation.body' },

    {
      kind: 'heading',
      level: 2,
      id: 'environments',
      textKey: 'docs.architecture.environments.heading',
    },
    { kind: 'paragraph', textKey: 'docs.architecture.environments.body' },

    { kind: 'heading', level: 2, id: 'next', textKey: 'docs.common.nextSteps' },
    {
      kind: 'cardGrid',
      cards: [
        {
          titleKey: 'docs.architecture.next.languages.title',
          textKey: 'docs.architecture.next.languages.text',
          to: { docSlug: 'languages' },
        },
        {
          titleKey: 'docs.architecture.next.trust.title',
          textKey: 'docs.architecture.next.trust.text',
          to: { path: '/trust' },
        },
      ],
    },
  ],
};
